import styled from "styled-components";
import { preventDrag } from "../../variables/Functions";
import { BREAKPOINTS } from "../../variables/Breakpoints";
import { setFlex, setPosition } from "../../variables/Position";
import { cursor } from "../../variables/Cursors";
import { COLOURS } from "../../variables/Colors";

export const Wrapper = styled.div`
  ${setPosition({ position: "relative", zIndex: 30 })};
  ${setFlex({ direction: "row" })};
  background-color: ${COLOURS.primary.black};
  height: 100vh;
  width: 100vw;
  cursor: grab;
  overflow: hidden;
  ${cursor("load")};
  &.grabbing {
    ${cursor("grabbing")};
  }
  &.defaults {
    min-height: 100vh;
  }
  ${preventDrag()};
  @media (max-width: ${BREAKPOINTS.md}px) {
    ${setFlex({ justify: "center", direction: "column" })};
  }
  @media (max-width: ${BREAKPOINTS.sm}px) {
    height: 100svh;
  }
`;

export const ImageWrapper = styled.div`
  ${setPosition({ position: "absolute", left: "0" })};
  width: 100%;
  height: 100%;
  ${preventDrag()};
  @media (max-width: ${BREAKPOINTS.md}px) {
    ${setPosition({ position: "relative" })};
    height: auto;
  }
  ${cursor("load")};
`;

export const DragImageWrapper = styled.div`
  ${setFlex({ justify: "center", align: "center" })};
  width: 100vw;
  height: 100vh;
  ${preventDrag()};
  @media (min-width: ${BREAKPOINTS.md}px) {
    transform: scaleX(0.5) scaleY(0.5);
    transform-origin: ${({ $isRight }) => ($isRight ? "center right" : "center left")};
  }
  @media (max-width: ${BREAKPOINTS.md}px) {
    height: auto;
  }
`;

export const DragImage = styled.img`
  height: auto;
  width: 100%;
  ${preventDrag()};
`;
